/**
 * Reusable animation keyframes and styles for Primaris components.
 *
 * Architecture:
 * - Keyframes defined with stylex.keyframes()
 * - Composable style objects exported via stylex.create()
 * - Uses duration/easing tokens for consistency
 * - Supports prefers-reduced-motion for accessibility
 */

import * as stylex from "@stylexjs/stylex";

import { duration, easing } from "./tokens.stylex.ts";

const shakeKeyframes = stylex.keyframes({
  "0%, 100%": { transform: "translate(0, 0) rotate(0deg)" },
  "5%": { transform: "translate(-2px, 1px) rotate(-1deg)" },
  "10%": { transform: "translate(2px, -1px) rotate(1deg)" },
  "15%": { transform: "translate(-1px, -1px) rotate(-0.5deg)" },
  "20%": { transform: "translate(1px, 2px) rotate(0.5deg)" },
  "25%": { transform: "translate(-2px, 0px) rotate(-1deg)" },
  "30%": { transform: "translate(2px, 1px) rotate(1deg)" },
  "35%": { transform: "translate(0px, -2px) rotate(-0.5deg)" },
  "40%": { transform: "translate(-1px, 1px) rotate(0.5deg)" },
  "45%": { transform: "translate(2px, -1px) rotate(-1deg)" },
  "50%": { transform: "translate(-2px, 2px) rotate(1deg)" },
  "55%": { transform: "translate(1px, 0px) rotate(-0.5deg)" },
  "60%": { transform: "translate(-1px, -1px) rotate(0.5deg)" },
  "65%": { transform: "translate(2px, 1px) rotate(-1deg)" },
  "70%": { transform: "translate(-2px, -2px) rotate(1deg)" },
  "75%": { transform: "translate(1px, 1px) rotate(-0.5deg)" },
  "80%": { transform: "translate(-1px, 0px) rotate(0.5deg)" },
  "85%": { transform: "translate(2px, -1px) rotate(-0.5deg)" },
  "90%": { transform: "translate(-1px, 1px) rotate(0.5deg)" },
  "95%": { transform: "translate(1px, -1px) rotate(-0.5deg)" },
});

const pulseRedKeyframes = stylex.keyframes({
  "0%": { backgroundColor: "transparent" },
  "50%": { backgroundColor: "rgba(239, 68, 68, 0.3)" },
  "100%": { backgroundColor: "transparent" },
});

export const animations = stylex.create({
  shake: {
    animationName: shakeKeyframes,
    animationDuration: "250ms",
    animationTimingFunction: easing.linear,
  },
  pulseRed: {
    animationName: pulseRedKeyframes,
    animationDuration: duration.slow,
    animationTimingFunction: easing.easeInOut,
  },
  reducedMotion: {
    "@media (prefers-reduced-motion: reduce)": {
      animationDuration: "0ms",
      transitionDuration: "0ms",
    },
  },
});
